<template>
      <div v-if="mainLoaded" class="cr-links">
        <div class="cr-links__title">
          {{ main.header2 }}
        </div>
        <ul v-if="main.menu.length > 0" class="cr-links__list">
          <li v-for="item in main.menu" class="cr-links__item">
            <router-link class="cr-links__link" :to="item[1]">
              {{item[0]}}
            </router-link>
          </li>
        </ul>
      </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters('main', [
      'main',
      'mainLoading',
      'mainError',
      'mainLoaded'
    ]),
  },
  created() {
    this.fetchMain();
  },
  methods: {
    ...mapActions('main', [
      'fetchMain'
    ]),
  }
}
</script>